import React from 'react';
import Tooltip from '../../../shared/Tooltip';

export default function AddressDetails({
  appAddress,
  type,
  tooltip,
  tooltip_text,
}) {
  if (!appAddress?.address1 && !tooltip)
    return (
      <div>
        <span className="mr-1.5 capitalize">{type} Address:</span>
        Not Provided
      </div>
    );

  if (!appAddress?.address1 && tooltip)
    return (
      <div>
        <span className="mr-1.5 capitalize font-avenir-black">
          {type} Address:
        </span>
        <Tooltip
          tooltip_text={tooltip_text}
          trigger_class="cursor-pointer font-avenir-book"
          container_class="text-center p-4 px-6 text-sm font-avenir-book normal-case text-navy-blue bg-light-blue max-w-sm"
        >
          N/A - NetX Applicant
        </Tooltip>
      </div>
    );

  return (
    <div className="mt-2">
      <span className="font-avenir-medium mt-1 tracking-wide text-navy-blue">
        {type} Address:
      </span>
      <p>{appAddress?.address1}</p>
      <p>{appAddress?.address2}</p>
      <p>
        {appAddress?.city}, {appAddress?.state}{' '}
        {appAddress?.zip.substring(0, 5)}
      </p>
    </div>
  );
}
